// Cloudinary configuration for browser environment
const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dz9qguszu';
const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'centron_aerospace_products'; // Custom upload preset

// Upload image to Cloudinary using unsigned upload
export const uploadImageToCloudinary = async (file) => {
  try {
    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      throw new Error('Invalid file type. Please upload an image (JPEG, PNG, GIF, WebP).');
    }

    // Validate file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      throw new Error('File size too large. Please upload an image smaller than 5MB.');
    }

    // Create FormData for upload
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    formData.append('cloud_name', CLOUDINARY_CLOUD_NAME);
    formData.append('folder', 'centron-aerospace/products');

    // Upload to Cloudinary
    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`Upload failed: ${errorData.error?.message || response.statusText}`);
    }

    const result = await response.json();

    return {
      success: true,
      url: result.secure_url,
      publicId: result.public_id
    };
  } catch (error) {
    console.error('Error uploading to Cloudinary:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Delete image from Cloudinary (requires server-side implementation)
export const deleteImageFromCloudinary = async (publicId) => {
  try {
    // Note: This requires server-side implementation for security
    // For now, we'll return success but actual deletion should be done server-side
    console.log('Image deletion should be implemented server-side for security');
    return {
      success: true,
      message: 'Image deletion requires server-side implementation'
    };
  } catch (error) {
    console.error('Error deleting from Cloudinary:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Test Cloudinary connection
export const testCloudinaryConnection = async () => {
  try {
    console.log('Testing Cloudinary connection...');
    console.log('Cloud Name:', CLOUDINARY_CLOUD_NAME);
    console.log('Upload Preset:', CLOUDINARY_UPLOAD_PRESET);
    
    return {
      success: true,
      message: 'Cloudinary configuration loaded successfully!'
    };
  } catch (error) {
    console.error('Cloudinary connection failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

const cloudinaryUtils = {
  uploadImageToCloudinary,
  deleteImageFromCloudinary,
  testCloudinaryConnection
};

export default cloudinaryUtils; 